import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { page as pageIndex, screenSize } from '../../globals'
import { updateData } from '../../store/reducers/updateData'
import DropdownField from '../FormComponents/DropdownField/DropdownField'
import TabsWrapper from '../ManagementTools/components/TabsWrapper'
import STSComponent from '../STSComponent/STSComponent'
import SubjectChangesRow from './components/SubjectChangesRow'
import { constants } from './constants'
import './css/ManagementSubjectChanges.scss'

class SubjectChanges extends STSComponent {
  returnTabsContent = () => {
    return <div className="subject-changes-body custom-scroll">
      <div className="subject-changes-record-found">2 records found</div>
      {window.innerWidth <= screenSize.extraSmall ? null : <div className="subject-changes-row">
        {constants.subjectTitles.map((item, i) => {
          return <div key={i} className={`subject-cell-${item.className}`}>
            {item.title}
          </div>
        })
        }
      </div>}
      {constants.data.map((item, i) => <SubjectChangesRow key={i} itemData={item} />)}
    </div>
  }

  render () {
    const { trackData, updateData } = this.props
    return <div className="subject-changes-wrapper">
      <div className="archived-year-wrap">
        <DropdownField
          id="archivedYear"
          location={{ page: pageIndex.dashboard, field: 'archivedYear', section: 'trackingStats' }}
          options={[]}
          value={trackData.archivedYear.radio.archivedYear}
          placeholder="Archived Year"
          updateData={updateData}
        />
      </div>
      <TabsWrapper
        legis={this.returnTabsContent('legis')}
        regs="regs"
        local="local"
      />
    </div>
  }

  static propTypes = {
    trackData: PropTypes.object,
    updateData: PropTypes.func
  }
}

export default connect(state => ({
  trackData: state.subjectChanges.formDataValue.D
}), {
  updateData
})(SubjectChanges)



// WEBPACK FOOTER //
// ./src/components/ManagementSubjectChanges/ManagementSubjectChanges.js